import { ReactComponent as SpotifyColorLight } from 'fym-shared/src/music-services/assets/images/spotify-color-light.svg';
import { ReactComponent as SpotifyColorDark } from 'fym-shared/src/music-services/assets/images/spotify-color-dark.svg';
import { ReactComponent as SpotifyColorLightPadding } from 'fym-shared/src/music-services/assets/images/spotify-color-light-padding.svg';
import { ReactComponent as SpotifyColorDarkPadding } from 'fym-shared/src/music-services/assets/images/spotify-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const spotifyImages: MusicServiceImages = {
  logoColor: {
    light: SpotifyColorLight,
    dark: SpotifyColorDark,
  },
  logoColorPadding: {
    light: SpotifyColorLightPadding,
    dark: SpotifyColorDarkPadding,
  },
};
